import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const EkuIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99549)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M24 12H8V8H3V12H0V24H24V12ZM7 0H4V2H7V0ZM11 3H0L2 7H9L11 3ZM18.028 5.20001L16.845 9H17.777L20.155 5.19901H22.761C22.8541 5.2009 22.9466 5.18396 23.033 5.14923C23.1194 5.11447 23.1979 5.06259 23.2638 4.99677C23.3296 4.93091 23.3815 4.85242 23.4162 4.76602C23.451 4.67963 23.4679 4.5871 23.466 4.49399C23.4686 4.3992 23.4517 4.30484 23.4165 4.2168C23.3812 4.12875 23.3283 4.04883 23.261 3.98199C23.125 3.84601 22.958 3.77701 22.761 3.77701H20.155L17.777 0H16.845L18.028 3.776H15.422L14.705 2.84399H14L14.466 4.495L14 6.155H14.705L15.422 5.20001H18.028ZM5.85156 21V20.0508H2.81934V18.1699H5.40771V17.2427H2.81934V15.5552H5.83838V14.6016H2.81934H2.4502H1.61084V21H2.4502H2.81934H5.85156ZM10.9316 21V20.0508H7.89941V18.1699H10.4878V17.2427H7.89941V15.5552H10.9185V14.6016H7.89941H7.53027H6.69092V21H7.53027H7.89941H10.9316ZM12.9795 17.5869V14.6016H11.771V21H12.9795V19.0839L13.6949 18.3192L15.4756 21H16.9126L14.4931 17.4309L16.8203 14.6016H15.3394L13.5903 16.7944L12.9795 17.5869ZM22.2432 14.6016H21.0347V18.8511C21.0347 19.1499 20.9863 19.3945 20.8896 19.585C20.793 19.7725 20.6538 19.9116 20.4722 20.0024C20.2935 20.0933 20.0781 20.1387 19.8262 20.1387C19.5771 20.1387 19.3618 20.0933 19.1802 20.0024C18.9985 19.9116 18.8579 19.7725 18.7583 19.585C18.6587 19.3945 18.6089 19.1499 18.6089 18.8511V14.6016H17.4004V18.8511C17.4004 19.3403 17.5044 19.752 17.7124 20.0859C17.9204 20.417 18.2075 20.6675 18.5737 20.8374C18.9399 21.0044 19.3574 21.0879 19.8262 21.0879C20.2891 21.0879 20.7021 21.0044 21.0654 20.8374C21.4287 20.6675 21.7158 20.417 21.9268 20.0859C22.1377 19.752 22.2432 19.3403 22.2432 18.8511V14.6016Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99549'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

EkuIcon.displayName = 'EkuIcon'
